import React from 'react';
import { ClientsTable } from '../components/clients/ClientsTable';

export const Clients = () => {
	return <ClientsTable />;
};
